var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('clinicList',{attrs:{"canEdit":true,"editRoute":"FranchiseClinicEdit","canCreate":true,"createRoute":"FranchiseClinicCreate","canViewDetail":true,"canViewClinicTreatmentHistory":true,"clinicTreatmentHistoryRoute":"FranchiseClinicTreatmentHistory"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }